import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { easyCAConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-currentaccount-easy',
    template: ''
})
export class CurrentAccountEasy implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.url.subscribe((segments) => {
      let native = segments.some((seg) => seg.path === 'native');
      this.route.queryParams.subscribe(async (params) => {
        const inApp = params['inApp'];
        const code = params['code'];
        if (native && code) {
          easyCAConfig.redirectUri =
            easyCAConfig.redirectUri + '/native?product=' + code;
        } else if (!native && inApp && code) {
          easyCAConfig.redirectUri =
            easyCAConfig.redirectUri + '?inApp=true&product=' + code;
        } else if (!native && !inApp && code) {
          easyCAConfig.redirectUri = easyCAConfig.redirectUri + '?product=' + code;
        } else if (native && !inApp && !code) {
          easyCAConfig.redirectUri = easyCAConfig.redirectUri + '/native';
        } else if (!native && inApp && !code) {
          easyCAConfig.redirectUri = easyCAConfig.redirectUri + '?inApp=true';
        } else {
          easyCAConfig.redirectUri = easyCAConfig.redirectUri;
        }
      });
    });
  }

  ngOnInit(): void {
    this.loginService.login(easyCAConfig);
  }
}
